import { MiniappSdkMethodDemo } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-method-demo';
import { MiniappSdkRedirectToContentDemo } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-redirect-to-content-demo';
import { MiniappSdkRootMethodDemo } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-root-method-demo';
import { MiniappSdkStorageGetDemo } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-storage-get-demo';
import { MiniappSdkStorageSetDemo } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-storage-set-demo';
import { MiniappSdkTokenizeCardDemo } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-tokenize-card-demo';
import { MiniappSdkShowNativePaymentAuth } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-show-native-payment-auth';
import { ChevronLeft } from 'lucide-react';
import { Accordion, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@hqo/ui-atoms';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export const MiniappSdkDemoPage = (): JSX.Element => {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <div className="flex flex-col gap-4 px-4 pb-4">
      <Breadcrumb>
        <BreadcrumbItem>
          <BreadcrumbLink onClick={handleBack} className="flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors">
            <ChevronLeft className="mr-1 h-4 w-4" />
            <FormattedMessage id="buttons.back" />
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Accordion type="multiple" className="flex w-full max-w-2xl flex-col gap-2">
        <MiniappSdkMethodDemo actionGroup="identity" action="getJWT" eventName="getJWTResponse" />
        <MiniappSdkMethodDemo actionGroup="identity" action="getUser" eventName="getUserResponse" />
        <MiniappSdkMethodDemo actionGroup="identity" action="getBuilding" eventName="getBuildingResponse" />
        <MiniappSdkMethodDemo actionGroup="identity" action="getBuildings" eventName="getBuildingsResponse" />
        <MiniappSdkMethodDemo actionGroup="host" action="getInfo" eventName="getHostInfoResponse" />
        <MiniappSdkMethodDemo actionGroup="payments" action="hideNativePayments" eventName="hideNativePaymentsResponse" />
        <MiniappSdkMethodDemo actionGroup="payments" action="getPaymentMethods" eventName="getPaymentMethodsResponse" />
        <MiniappSdkMethodDemo actionGroup="header" action="showHeader" eventName="showHeaderResponse" />
        <MiniappSdkMethodDemo actionGroup="header" action="hideHeader" eventName="hideHeaderResponse" />
        <MiniappSdkRootMethodDemo action="refreshToken" eventName="refreshTokenResponse" />
        <MiniappSdkRedirectToContentDemo />
        <MiniappSdkTokenizeCardDemo />
        <MiniappSdkStorageGetDemo />
        <MiniappSdkStorageSetDemo />
        <MiniappSdkShowNativePaymentAuth />
      </Accordion>
    </div>
  );
};
